import { ConsentState, IDataLayerEvent, IDataLayerItem } from 'components/SeoSuite/interfaces/IDataLayer';
import { IGtmProduct } from 'components/SeoSuite/interfaces/IGtmEventDetail';

export const GTM_EVENT = {
    viewItemList: 'view-item-list',
    cartAltered: 'cart-altered',
    checkoutStepProceed: 'checkout-step-proceed',
    search: 'search-performed',
};

const roundPrice = (price: number): number => parseFloat((price || 0).toFixed(2));

/**
 * Stamped onto every event rather than rendered server side, so the page cache stays customer agnostic.
 */
let userId: string | null = null;

export const setUserId = (id: string | null): void => {
    userId = id;
};

/**
 * gtag() is declared by the Google Tag Manager snippet, so everything no-ops when GTM is switched off.
 */
export const pushDataLayer = (event: IDataLayerEvent): void => {
    window.gtag?.({ user_id: userId, ...event });
};

export const updateConsent = (consent: Record<string, ConsentState>): void => {
    window.gtag?.('consent', 'update', consent);
};

export const getCurrencyCode = (): string => window.STORE_CURRENCY_CODE ?? 'EUR';

export const toDataLayerItem = (product: IGtmProduct): IDataLayerItem => {
    const item: IDataLayerItem = {
        item_id: product.sku,
        item_name: product.name,
        price: roundPrice(product.price),
    };

    if (product.brand) {
        item.item_brand = product.brand;
    }

    if (product.quantity !== undefined) {
        item.quantity = product.quantity;
    }

    if (product.index !== undefined) {
        item.index = product.index;
    }

    if (product.list) {
        item.item_list_id = product.list.id;
        item.item_list_name = product.list.name;
    }

    return item;
};

export const getItemsValue = (items: IDataLayerItem[]): number =>
    roundPrice(items.reduce((sum, item) => sum + (item.price ?? 0) * (item.quantity ?? 1), 0));
